function mergeDistinct(originalEdges, newEdges) {
  const merged = [];
  merged.push(...originalEdges);

  // eslint-disable-next-line no-underscore-dangle
  const originalRefs = new Set(originalEdges.map((edge) => edge.node.__ref));
  newEdges.forEach((newEdge) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!originalRefs.has(newEdge.node.__ref)) {
      merged.push(newEdge);
    }
  });
  return merged;
}

export const pagination = {
  read(existing) {
    return existing;
  },
  merge(_existing, { __typename, edges, pageInfo }, { args }) {
    const existing = _existing || { edges: [] };
    const merged = mergeDistinct(existing?.edges, edges);
    return {
      __typename,
      pageInfo,
      edges: args?.after && args?.after !== '' ? merged : edges,
      args,
    };
  },
};

export const productVariants = {
  keyArgs: ['productId', 'colorId', 'product_CategoryId'],
  read(existing) {
    return existing;
  },
  merge(_existing, { __typename, edges, pageInfo }, { args }) {
    const existing = _existing || { edges: [] };
    const merged = mergeDistinct(existing?.edges, edges);
    return {
      __typename,
      pageInfo,
      edges: args?.after && args?.after !== '' ? merged : edges,
    };
  },
};

export const getNodeCacheKey = (nodeId, typename) => ({ id: nodeId, __typename: typename });

export const getUserId = () => getNodeCacheKey(localStorage.getItem('userId'), 'UserNode');

export const addNode = (val, data, fragment, cache, __typename) => {
  const node = cache.writeFragment({
    data,
    fragment,
  });

  return {
    ...val,
    edges: [...val.edges, { __typename, node }],
  };
};

export const removeNode = (val, readField, modelId) => ({
  ...val,
  edges: val.edges?.filter(({ node }) => modelId !== readField('id', node)),
});

export const removeNodes = (val, readField, edges) => {
  const values = val.edges.reduce((prev, value) => {
    const id = readField('id', value.node);
    const find = edges.find(({ node }) => node.id === id);
    return find ? prev : [...prev, value];
  }, []);
  return { ...val, edges: values };
};
